import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import WithLayout from './WithLayout'; // Ensure correct path
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import {
  // Home as HomeView,
  Home as Home,
  Solutions as SolutionsView,
  ONDC as ONDCView,
  About as AboutView,
  NotFound as NotFoundView,
  NotFoundCover as NotFoundCoverView,
  Policies as PolicyView,
  ProfileDelete as ProfileDeleteView,
  ProfileDeleteApp as ProfileDeleteAppView,
  Support as SupportView,
} from './views';

import { Redirect as RedirectComponent } from 'components/atoms';

const RoutesConfig = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WithLayout
            component={Home}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/solutions/:solutionName"
        element={
          <WithLayout
            component={SolutionsView}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/ondc"
        element={
          <WithLayout
            component={ONDCView}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/policy/:policyName"
        element={
          <WithLayout
            component={PolicyView}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/profile/delete"
        element={
          <WithLayout
            component={ProfileDeleteView}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/delete-my-account/:appname"
        element={
          <WithLayout
            component={ProfileDeleteAppView}
            layout={MainLayout}
          />
        }
      />

      {/* <Route
        path="/home"
        element={
          <WithLayout
            component={HomeView}
            layout={MainLayout}
          />
        }
      />
       <Route
        path="/solution-offering"
        element={
          <WithLayout
            component={SolutionOfferingView}
            layout={MainLayout}
          />
        }
      /> */}
      <Route
        path="/support"
        element={
          <WithLayout
            component={SupportView}
            layout={MainLayout}
          />
        }
      />
      <Route
        path="/about"
        element={
          <WithLayout
            component={AboutView}
            layout={MainLayout}
          />
        }
      />
      
      <Route
        path="/not-found"
        element={
          <WithLayout
            component={NotFoundView}
            layout={MinimalLayout}
          />
        }
      />
      <Route
        path="/not-found-cover"
        element={
          <WithLayout
            component={NotFoundCoverView}
            layout={MinimalLayout}
          />
        }
      />
      <Route path="/:appname/:encodeded?" element={<RedirectComponent />} />
      <Route path="*" element={<Navigate to="/not-found-cover" replace />} />
    </Routes>
  );
};

export default RoutesConfig;
